import classNames from "classnames";
import React from "react";
import _ from "underscore";

import { actions } from "react-redux-form";
import { Dispatch } from "redux";
import { Errors, RadioButton } from "../../../../core/atoms/rrf";
import { CommonProps, EnquiryFormSection } from "./common";
import { FormProgressIcon } from "./formProgressIcon";

interface OwnProps {
  dispatch: Dispatch<IWebStoreState>;
}

export class TripTypeSelect extends EnquiryFormSection<OwnProps> {
  public constructor(props) {
    super(props);
  }

  protected shouldUpdateValidity(oldProps: CommonProps, newProps: CommonProps) {
    return !_.isEqual(oldProps.formState.tripType, newProps.formState.tripType);
  }

  protected syncValidity(formState: Forms.EnquiryForm) {
    this.props.dispatch(actions.setErrors(this.props.model, { required: formState.tripType == null }));
  }

  public render() {
    const { model, className, id, formState } = this.props;

    return (
      <section id={id} className={classNames("trip-type-select", className)}>
        <header>
          <FormProgressIcon model={model} />
          <h2>What kind of accommodation would you like?</h2>
        </header>

        <div className="enquiry-form-question enquiry-form-radio-select">
          <Errors model={model} messages={{ required: "Please select an option" }} />

          <RadioButton
            model={model}
            id={`trip-type-${TripType.Simple}`}
            value={TripType.Simple}
            label="Simple (2* - 3*)"
            subLabel="Clean and simple, nothing more"
            getValue={e => parseInt((e as React.ChangeEvent<HTMLInputElement>).target.value)}
          />

          <RadioButton
            model={model}
            id={`trip-type-${TripType.Boutique}`}
            value={TripType.Boutique}
            label="Boutique/ Character (3* - 4*)"
            subLabel="Accommodation with character where available"
            getValue={e => parseInt((e as React.ChangeEvent<HTMLInputElement>).target.value)}
          />

          <RadioButton
            model={model}
            id={`trip-type-${TripType.Luxury}`}
            name="trip-type"
            value={TripType.Luxury}
            label="Deluxe (4* - 5*)"
            subLabel="More luxurious accommodation throughout your trip"
            getValue={e => parseInt((e as React.ChangeEvent<HTMLInputElement>).target.value)}
          />

          <RadioButton
            model={model}
            id={`trip-type-${TripType.Unknown}`}
            value={TripType.Unknown}
            label="A mixture"
            subLabel="Our local experts will recommend a mix of accommodation types"
            getValue={e => parseInt((e as React.ChangeEvent<HTMLInputElement>).target.value)}
          />
        </div>
      </section>
    );
  }
}
